// Appointment / schedule api fns — carved verbatim from
// `src/api/scribeAPIV2.ts` (which now re-exports them) as D1 of the
// `integrations/ehr` family (ARCFE-1087).
//
// `getIntegrationsSchedule`'s conditional `paramsSerializer: { indexes: null }`
// is not cosmetic: FastAPI expects repeated `filter` params WITHOUT brackets,
// and axios's default serializer emits `filter[]=`. It is applied only when
// filters are present, exactly as in the hub.
import type {
  GetIntegrationSchedulesResponse,
  GetIntegrationsScheduleRequestParams,
  SearchAppointmentResponse,
} from '../../contracts/types';
import { http } from './ehrHttp';

export const getEHRAppointments = (date: string) => {
  return http().get<SearchAppointmentResponse>('/ehr/appointments', {
    params: { selected_date: date },
  });
};

export const getIntegrationsSchedule = (params: GetIntegrationsScheduleRequestParams) => {
  return http().get<GetIntegrationSchedulesResponse>('/integrations/schedule', {
    params,
    ...(params.filter?.length
      ? {
          // FastAPI expects repeated filter params without brackets.
          paramsSerializer: { indexes: null },
        }
      : {}),
  });
};
